/*jshint multistr: true */

$(function () {

    function checkSelectOptions() {

    (function(jQuery) {
        jQuery.fn.clickoutside = function(callback) {
            var outside = 1, self = $(this);
            self.cb = callback;
            this.click(function() {
                outside = 0;
            });
            $(document).click(function() {
                outside && self.cb();
                outside = 1;
            });
            return $(this);
        };
    })(jQuery);

        function getURL(name, url) {

            if (!url) url = window.location.href;

            name = name.replace(/[\[\]]/g, "\\$&");

            var regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
                results = regex.exec(url);

            if (!results) return null;

            if (!results[2]) return '';

            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        var $section = getURL('section');

        if ( !$section ) $('.js_sectionSelect').val('');
    }

    // fake select
    function initSelect() {

        $('.js_selectWrap').each(function() {

            var el = $(this),
                $btn = el.find('.fake_form_select__btn'),
                $list = el.find('.fake_form_select__list'),
                $item = el.find('.fake_form_select__item'),
                select = el.find('.fake_form_select__box'),
                selected = $('.js_selectedSection');

            el.addClass('js_selectWrapFN');

            $btn.on('click', function() {

                setTimeout(function (){
                    $list.addClass('is_visible');
                }, 15);

            });

            $list.clickoutside(function() {

                if( $list.hasClass('is_visible') ) {
                    $list.removeClass('is_visible');
                }
            });

            $item.on('click', function(e){

                var _item_text  = $(this).html(),
                    _item_value = $(this).data('value'),
                    option = select.find(`option[value="${_item_value}"]`);

                $list.removeClass('is_visible');
                $btn.html(_item_text);
                select.val(_item_value);

            });

            if ( selected.html() ) {

                var option = select.find(`option[value="${selected.html()}"]`);
                $btn.html(option.html());

            }
        });

        // Dodano punjenje fake polja sa stringom "Sve rubrike" ako nijedna rubrika nije selektirana
        var fakeSelect = $('.js_fakeSectionSelect'),
            fakeText = fakeSelect.text();

        if (fakeText == '\xa0') {

            fakeSelect.text(fakeSelect.data('default'));
        }
    }

    function initDatepicker() {

        $('.js_datePickerSearch').each(function() {

            var initDate = $(this).val();

            if ( initDate.indexOf('-') ) {
                initDate = initDate.split('-').reverse().join('.');
            }

            $(this).val(initDate);

            var _selectedDate, _splitDate;

            if ( initDate ) {
                _splitDate = initDate.split('.');
                _selectedDate = new Date ( _splitDate[2], _splitDate[1] - 1, _splitDate[0] );
            } else {
                _selectedDate = new Date ();
            }

            $(this).glDatePicker({
                onClick: function(target, cell, date, data) {
                    var datestring = ("0" + date.getDate()).slice(-2) + "." + ("0"+(date.getMonth()+1)).slice(-2) + "." + date.getFullYear();
                    target.val(datestring);
                },

                monthNames: ['Januar', 'Februar', 'Marec', 'April', 'Maj', 'Junij', 'Julij', 'Avgust', 'September', 'Oktober', 'November', 'December'],
                dowNames: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],

                selectableDateRange: [{from: new Date(2013, 1, 1), to: new Date() }],

                selectedDate: _selectedDate,
            });
        });
    }

    function initExtraSearch() {

        $('.js_searchFormBtn').on('click', function(evt) {

            evt.preventDefault();
            $('.js_searchForm').submit();

        });
    }

    function initClearFilters() {
        $('.js_clearFilters').on('click', function(e){
            e.preventDefault();
            $('.js_sectionSelect, .js_datePickerSearch, .search__form_input, .js_orderSelection').val('');

            $('.search__form_select_btn').each(function(){
                $(this).text( $(this).data('default') );
                $(this).closest('.js_selectWrap').find('option').remove();
            });

            $('.js_searchForm').submit();
        });
    }

    checkSelectOptions();
    initSelect();
    initDatepicker();
    initExtraSearch();
    initClearFilters();

});
